import interpolate from './interpolate';
var interpolateArray = function (from, to, k, interpolateMap) {
    var ret = to.slice();
    for (var i = 0; i < to.length; i++) {
        ret[i] = interpolate(from[i], to[i], k, interpolateMap);
    }
    return ret;
};
export default interpolateArray;
